module.exports = __webpack_public_path__ + "img/BRAND-03.68a32801.jpg";